import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VerifiedPnlComponent } from './verified-pnl.component';

const routes: Routes = [
  {path:'', component:VerifiedPnlComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VerifiedPnlRoutingModule { }
